import {CMEDirectTrade, Trade} from "../../../types/APITypes";
import AccountService from '../../../services/account.service';
import {DateTime} from 'luxon';
import {fromJSDateToDateTime, mergeDateTime} from "../TradeFormatUtils";

export async function formatCmeTrade(cmeTradeData: CMEDirectTrade): Promise<Trade> {
    const profile = JSON.parse(localStorage.getItem('userProfile') || '{}');
    const userCompany = profile.ownerShortName;
    let mappedData = {} as Trade;
    const contractRegex = /^(\D{3})(\d{2})\s(\d+\.\d+)\s(\w+)$/;
    const partyRegex = /(.*)\/(.*)$/;

    // @ts-ignore
    const _tradeDate = DateTime.fromJSDate(cmeTradeData["Trade Date"]).setZone("utc");
    if (!_tradeDate.isValid) {
        console.log('TradeDate :', cmeTradeData["Trade Date"], cmeTradeData["Exec Time"]);
    } else {
        mappedData.tradeDate = _tradeDate.toISODate();
        // @ts-ignore
        let executionTime = mergeDateTime(_tradeDate, fromJSDateToDateTime(cmeTradeData["Exec Time"]));
        // @ts-ignore
        mappedData.executionTime = executionTime.toISO();
        // @ts-ignore
        let createdTime = mergeDateTime(_tradeDate, fromJSDateToDateTime(cmeTradeData["Created Time"]));
        // @ts-ignore
        mappedData.giveupTime = createdTime.toISO();
    }

    mappedData.sourceSystem = 'CMEDirect';

    // Default to a Future
    mappedData.assetClass =  'Future';
    // Construct an 'aliasable' code for MIC.
    mappedData.mic = `${cmeTradeData.CC}:${cmeTradeData.CH}`;
    mappedData.instrumentCode = cmeTradeData.CC;
    mappedData.productDescription = cmeTradeData.Product;
    mappedData.price = +cmeTradeData.Price;
    mappedData.quantity = +cmeTradeData["Cleared Contracts"];
    mappedData.executingBroker = userCompany;
    mappedData.tradeID = cmeTradeData["Trade ID"]?.toString();
    mappedData.traceID = cmeTradeData["Deal ID"]?.toString();
    mappedData.tradeType = cmeTradeData.Type?.toString();
    mappedData.sourceSystem = cmeTradeData.Source?.toString();

    if (cmeTradeData.Description) {
        const match = cmeTradeData.Description.match(contractRegex);
        if (match) {
            const _maturityString = match[1] + match[2];
            let _maturity = DateTime.fromFormat(_maturityString, "MMMyy");
            // @ts-ignore
            mappedData.maturity =  _maturity.toISODate();
            mappedData.strike = +match[3];
            mappedData.optionType = match[4]?.toUpperCase().startsWith('P') ? 'Put' : match[4]?.toUpperCase().startsWith('C') ? 'Call' : undefined;
            mappedData.assetClass =  'Option';
        }
    }

    if (cmeTradeData["S Acct"] || cmeTradeData["B Acct"]) {

        const setParties = (
            side:string, owner:string, name:string,
             client:string, clientTrader:string|undefined,
            contraTrader: string|undefined) => {
            mappedData.side = side;
            mappedData.clearingBroker = owner
            mappedData.clearingAccount = name;
            mappedData.client = client;
            mappedData.clientTrader = clientTrader;
            mappedData.contraTrader = contraTrader;
        };


        // First lookup all the account numbers in the cache
        const storageKeys = ['axios-cache-account', 'axios-cache-alias'];
        for (const key of storageKeys) {
            const storedData = localStorage.getItem(key);
            if (storedData) {
                try {
                    const item = JSON.parse(storedData);
                    if (!item) {
                        console.log('Warning alias and account caches may not be pre-loaded');
                    }
                    item.data.data.result?.forEach((entry: {
                        owner: string;
                        client: string;
                        name: string;
                    }) => {
                        // @todo why do account number strings get converted to numbers when cached.??
                        if (cmeTradeData['S Acct']?.toString() === entry.name?.toString()) {
                            setParties('Sell', entry.owner, entry.name, entry.client,
                                cmeTradeData.Seller?.toString(), cmeTradeData.Buyer?.toString());
                        } else if (cmeTradeData['B Acct']?.toString() === entry.name?.toString()) {
                            setParties('Buy', entry.owner, entry.name, entry.client,
                                cmeTradeData.Buyer?.toString(), cmeTradeData.Seller?.toString());
                        }
                    }
                    );
                    //determineSide(item);
                    if (mappedData.side) {
                        break;
                    }
                } catch (e) {
                    console.error('Failed to parse JSON for key:', key, e);
                }
            }
        }

        // As the 'Side' should be resolved now, if its not been then we need to lookup the account numbers from server side.
        if (!mappedData.side) {
            const sellerAccount = cmeTradeData['S Acct'] ? await AccountService.getAccountOrAlias(cmeTradeData['S Acct']) : undefined;
            if (sellerAccount?.result) {
                setParties('Sell', sellerAccount.result?.owner, sellerAccount.result?.name,
                    sellerAccount.result?.client,
                    cmeTradeData.Seller?.toString(), cmeTradeData.Buyer?.toString());
            } else {
                const buyerAccount = cmeTradeData['B Acct'] ? await AccountService.getAccountOrAlias(cmeTradeData['B Acct']) : undefined;
                if (buyerAccount?.result) {
                    setParties('Buy', buyerAccount.result?.owner, buyerAccount.result?.name,
                        buyerAccount.result?.client,
                        cmeTradeData.Buyer?.toString(), cmeTradeData.Seller?.toString());
                }
            }
        }
    }
    return mappedData;
}
